export default {
    formId: 'createTerminalDescansosForm', //'createTerminalForm',
    formField: {
      name: {
        name: 'name',
        label: 'Nombre terminal descansos*',
        requiredErrorMsg: 'El nombre es requerido.'
      },
      description: {
        name: 'description',
        label: 'Descripcion*',
        requiredErrorMsg: 'La descripcion es requerida.'
      },
      typeTerminal: {
        name: 'typeTerminal',
        label: 'Tipo terminal',
        requiredErrorMsg: 'El tipo de terminal es requerida.'
      },
    }
};
  